enum OfferDistributionStatus {
    Pending = 'pending',
    Ongoing = 'ongoing',
    Complete = 'complete',
    Failed = 'failed'
}

export default OfferDistributionStatus